export default __webpack_public_path__ + "static/media/chart.baa08742.png";